import { FC } from "react";
import { IProductCard } from "types/product";
import ProductCard from "./ProductCard";
import ProductCardHorizontal from "./ProductCardHorizontal";
import { Empty } from "antd";
import useIsDesktopStore from "stores/isDesktop";

interface IProductList {
  isList: boolean;
  isLoading: boolean;
  data?: IProductCard[];
}

const ProductList: FC<IProductList> = ({ isList, isLoading, data }) => {
  const { isDesktop } = useIsDesktopStore();
  if (isLoading || !data) {
    return <div />;
  }

  if (data.length === 0) {
    return (
      <div className="flex justify-center items-center h-96 w-full">
        <Empty
          description={
            <div>
              <div className="text-black font-semibold text-xl">
                ไม่พบสินค้า
              </div>
            </div>
          }
        />
      </div>
    );
  }

  if (isDesktop) {
    if (isList) {
      return (
        <div className="flex gap-4 flex-wrap">
          {data.map((d) => {
            return (
              <ProductCardHorizontal key={`${d.id} ${d.isFavorite}`} {...d} />
            );
          })}
        </div>
      );
    }
    return (
      <div className="flex gap-2 flex-wrap">
        {data.map((d) => {
          return <ProductCard key={`${d.id} ${d.isFavorite}`} {...d} />;
        })}
      </div>
    );
  }
  if (isList) {
    return (
      <div className="flex gap-4 flex-wrap">
        {data.map((d) => {
          return (
            <ProductCardHorizontal key={`${d.id} ${d.isFavorite}`} {...d} />
          );
        })}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
      {data.map((d) => {
        return <ProductCard key={`${d.id} ${d.isFavorite}`} {...d} />;
      })}
    </div>
  );
};
export default ProductList;
